import $ from 'jquery';
import _ from 'lodash';

import ResponsiveService from '../responsive';
import constants from './Video/constants';
import VideoMediaMatchService from './mediaMatch';
import OCError from '../../Exceptions/OCError';
import thumbnailService from './Video/thumbnail';

const videoElements = [];
const VideoService = {};

const thumbnailTemplate = _.template(
  [
    '<div class="video-thumb video-thumb--locked">',
    '   <i class="video-thumb__default-icon icon-video"></i>',
    '   <img class="video-thumb__image" src="<% if (typeof thumbnailUrl === "string") { %><%= thumbnailUrl %><% } %>">',
    '</div>',
  ].join('')
);

const getIframeElement = (function () {
  let playerCount = 0;

  return function () {
    const $iframeElement = $('<iframe></iframe>');

    $iframeElement.attr({
      id: `video_Player_${(playerCount += 1)}`,
      src: 'about:blank',
      frameborder: 0,
    });

    return $iframeElement;
  };
})();

function resizeIframeVideo($videoElement) {
  const widthMax = $videoElement.width();
  const height = widthMax / constants.VIDEO_RATIO;

  $videoElement.css('width', '');
  $videoElement.height(height);
}

VideoService.videoToIframe = function (element) {
  const $video = $(element);
  const src = $video.attr('src');
  const label = $video.attr('aria-label');
  let $iframe;
  let iframeUrl;

  if (!src) {
    OCError.throwException(constants.NOT_A_VIDEO_ELEMENT_EXCEPTION);
  }

  $iframe = $(getIframeElement());
  iframeUrl = VideoMediaMatchService.getIframeUrl(src);

  $iframe
    .insertAfter($video)
    .addClass('video js-claire-video')
    .attr('data-src-origine', src)
    .attr('title', label);

  if (!label) {
    $iframe.attr('title', constants.DEFAULT_LABEL);
  }

  $video.remove();

  $iframe.data('video', {
    type: VideoMediaMatchService.getTypeFromUrl(src),
  });

  $iframe.attr('webkitallowfullscreen', '');
  $iframe.attr('mozallowfullscreen', '');
  $iframe.attr('allowfullscreen', '');

  $iframe.attr('src', iframeUrl);

  // keep the iframes in an array
  videoElements.push($iframe);

  resizeIframeVideo($iframe);

  return $iframe;
};

VideoService.iframeToVideo = function (element, asDomElement = false) {
  let $video;
  const $iframe = $(element);
  const src = $iframe.attr('data-src-origine');
  let label = $iframe.attr('title');

  if (!label) {
    label = constants.DEFAULT_LABEL;
  }

  if (src) {
    $video = $('<video>').attr('src', src).attr('aria-label', label);

    return asDomElement ? $video[0] : $video;
  }
};

VideoService.videoToThumbnail = function (videoElement) {
  let $img;
  const $video = $(videoElement);
  const srcPromise = thumbnailService.getVideoThumbnailUrl($video.attr('src'));
  const $thumb = $(thumbnailTemplate());

  $img = $('img', $thumb)
    .on('load', () => {
      $thumb.removeClass('video-thumb--loading video-thumb--error');
    })
    .on('error', () => {
      $thumb.removeClass('video-thumb--loading').addClass('video-thumb--error');
    });

  $thumb
    .data($video.data())
    .addClass($video.attr('class'))
    .addClass('video-thumb--loading')
    .insertAfter($video);

  srcPromise.done((thumbnailUrl) => {
    if (thumbnailUrl) {
      $img.attr('src', thumbnailUrl);
    } else {
      $img.remove();
    }
  });

  $video.remove();
  return $thumb;
};

ResponsiveService.registerOnResizeCallback(() => {
  videoElements.forEach(($videoElement) => {
    resizeIframeVideo($videoElement);
  });
});

$(document).on(
  'webkitfullscreenchange mozfullscreenchange fullscreenchange MSFullscreenChange',
  () => {
    videoElements.forEach(($videoElement) => {
      resizeIframeVideo($videoElement);
    });
  }
);

export default VideoService;
